import * as topbarActions from './actions';

const initialState = {
  showProfile: false,
  showNotification: false,
  showSidebar: false,
  topbarMessage: {
    open: false
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case topbarActions.OPEN_PROFILE_MENU:
      return {
        ...state,
        showProfile: true,
        showNotification: false
      };
    case topbarActions.CLOSE_PROFILE_MENU:
      return {
        ...state,
        showProfile: false
      };
    case topbarActions.TOGGLE_PROFILE_MENU:
      return {
        ...state,
        showProfile: !state.showProfile,
        showNotification: false
      };
    case topbarActions.SHOW_NOTIFICATION:
      return {
        ...state,
        showNotification: true,
        showProfile: false
      };
    case topbarActions.CLOSE_NOTIFICATION:
      return {
        ...state,
        showNotification: false
      };
    case topbarActions.TOGGLE_NOTIFICATION:
      return {
        ...state,
        showNotification: !state.showNotification,
        showProfile: false
      };
    case topbarActions.CLOSE_ALL_MENU:
      return {
        ...state,
        showNotification: false,
        showProfile: false
      };
    case topbarActions.SHOW_SIDEBAR:
      return {
        ...state,
        showSidebar: true,
        showProfile: false,
        showNotification: false
      };
    case topbarActions.CLOSE_SIDEBAR:
      return {
        ...state,
        showSidebar: false,
        showProfile: false,
        showNotification: false
      };
    case topbarActions.TOGGLE_SIDEBAR:
      return {
        ...state,
        showSidebar: !state.showSidebar,
        showProfile: false,
        showNotification: false
      };
    case topbarActions.SHOW_TOPBAR_MESSAGE:
      return {
        ...state,
        topbarMessage: {
          open: true,
          variant: action.variant,
          message: action.message
        }
      };
    case topbarActions.CLOSE_TOPBAR_MESSAGE:
      return {
        ...state,
        topbarMessage: {
          open: false
        }
      };
    default:
      return state;
  }
};

export function showNotificationMenu(state) {
  return state.showNotification;
}

export function showProfileMenu(state) {
  return state.showProfile;
}

export function showSideBar(state) {
  return state.showSidebar;
}

export function getTopbarMessage(state) {
  return state.topbarMessage;
}
